import {
  Alert,
  AutoComplete,
  Badge,
  Breadcrumb,
  Button,
  Card,
  Carousel,
  Cascader,
  Checkbox,
  Col,
  Collapse,
  ConfigProvider,
  DatePicker,
  Divider,
  Dropdown,
  Form,
  Icon,
  Input,
  InputNumber,
  List,
  Menu,
  message,
  Modal,
  Pagination,
  Popover,
  Radio,
  Row,
  Select,
  Spin,
  Steps,
  Switch,
  Table,
  Tabs,
  Tag,
  Upload
} from 'ant-design-vue';
import axios from 'axios';
import Vue from 'vue';
import App from './app.vue';
import router from './router';
import store from './store';
Vue.use(Alert);
Vue.use(AutoComplete);
Vue.use(Badge);
Vue.use(Breadcrumb);
Vue.use(Button);
Vue.use(Card);
Vue.use(Carousel);
Vue.use(Cascader);
Vue.use(Checkbox);
Vue.use(Col);
Vue.use(Collapse);
Vue.use(ConfigProvider);
Vue.use(DatePicker);
Vue.use(Divider);
Vue.use(Dropdown);
Vue.use(Form);
Vue.use(Icon);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(List);
Vue.use(Menu);
Vue.use(Modal);
Vue.use(Pagination);
Vue.use(Popover);
Vue.use(Radio);
Vue.use(Row);
Vue.use(Select);
Vue.use(Spin);
Vue.use(Steps);
Vue.use(Switch);
Vue.use(Table);
Vue.use(Tabs);
Vue.use(Tag);
Vue.use(Upload);

Vue.config.productionTip = false;

const { VUE_APP_CSRF: CSRF } = process.env;

/* --------- axios setting --------- */
axios.defaults.withCredentials = true;

/* --------- csrf setting --------- */
axios.interceptors.request.use((config) => {
  config.xsrfHeaderName = 'X-CSRF-TOKEN';
  config.xsrfCookieName = CSRF;
  return config;
});

// axios.interceptors.response.use((response) => {
//   console.log('response', response);
//   return response;
// });

Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$axios = axios;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
